type TableDataWithCreated = {
  Created: string;
  StartDate?: string;
};

export const sortTableDataByDateTime = <T extends TableDataWithCreated>(
  tableData: T[]
): T[] => {
  const today = new Date().getTime();

  const sortedData = [...tableData].sort((a, b) => {
    if (a.Created) {
      const aDiff = today - new Date(a.Created).getTime();
      const bDiff = today - new Date(b.Created).getTime();
      return aDiff - bDiff;
    } else {
      const aDiff = today - new Date(a.StartDate).getTime();
      const bDiff = today - new Date(b.StartDate).getTime();
      return aDiff - bDiff;
    }
  });

  return sortedData;
};
